import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, ease: EASE, delay }}
        >
            {children}
        </motion.div>
    );
}

export function Eyebrow({ children, className = "" }) {
    return (
        <div className={`flex items-center gap-4 ${className}`}>
            <span className="h-px w-10 bg-gold/70" />
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-gold">
                {children}
            </span>
        </div>
    );
}
